<template>
  <div>
    <div class="text-xs-right">
      <v-btn small outline color="primary" @click="switchView">{{
        type == 'ui' ? 'View code' : 'Hide code'
      }}</v-btn>
    </div>
    <template v-if="type == 'ui'">
      <span>altText:</span>
      <div class="form-control mb-2">
        <input type="text" @input="onChange" v-model="dataAltText" maxlength="400" />
      </div>
      <v-radio-group row v-model="hasLinkUrl" class="mb-3 text-xs-left">
        <v-radio color="primary" label="มี Link URL" :value="true"></v-radio>
        <v-radio color="primary" label="ไม่มี Link URL" :value="false"></v-radio>
      </v-radio-group>
      <div
        v-if="hasLinkUrl === true"
        class="form-control mb-2"
        :class="{ 'has-error': errors.has('linkuri') }"
      >
        <input
          placeholder="Enter Link URL"
          name="linkuri"
          v-validate="'required|isUrl|isHttps'"
          :data-vv-as="$t('Link URL')"
          v-model="linkurl"
          type="text"
        />
        <div class="caption grey--text">{{ $t('The Link must begin with https://') }}</div>
        <span class="text-error" v-if="errors.has('linkuri')">{{ errors.first('linkuri') }}</span>
      </div>
      <uploadfile @input="onUploaded" v-model="image_url" :scaleWidth="1040"></uploadfile>
      <div class="clearfix"></div>
      <ul class="mt-2" style="list-style-type: disc; padding-left: 24px;">
        <li>Image format: JPEG or PNG</li>
        <li>Image width: 240px, 300px, 460px, 700px, 1040px</li>
        <li>Max file size: 10 MB</li>
      </ul>
    </template>
    <template v-else>
      <codemirror
        ref="cmCode"
        v-model="code"
        :options="cmOptions"
        @input="onCmCodeChange"
      ></codemirror>
    </template>

    <div class="caption mt-2 warning--text">
      {{ $t('This messages will not be shown on ') + $t('facebook') + $t('and') + $t('instagram') }}
    </div>

    <div class="text-xs-center py-2 mt-4">
      <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="onSave">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'

// require styles
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-light.css'
// require active-line.js
import 'codemirror/addon/selection/active-line.js'
// closebrackets
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/display/autorefresh.js'
import uploadfile from '@/components/elements/uploadfile.vue'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'image_url_edit', 'altText'],
  data: function() {
    return {
      dataAltText: 'This is an imagemap',
      hasLinkUrl: false,
      linkurl: null,
      type: 'ui',
      code: '',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        lineNumbers: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        styleSelectedText: true,
        styleActiveLine: true,
        theme: 'base16-light',
        line: true,
        autoFocus: true,
        autoRefresh: true
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      image_url: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  components: {
    codemirror,
    uploadfile
  },
  async mounted() {
    if (this.value) {
      this.code = this.value
      this.dataAltText = this.altText ? this.altText : 'This is an imagemap'
    }

    if (this.image_url_edit) {
      this.updateImage(this.image_url_edit)
    }
    await this.$nextTick()
    if (this.$refs.cmCode) this.$refs.cmCode.codemirror.refresh()
  },
  methods: {
    onChange() {
      var code = JSON.parse(this.code)
      code.altText = this.dataAltText
      this.code = JSON.stringify(code)
    },
    updateImage(img) {
      var value = JSON.parse(this.value)
      // console.log(value.actions)
      var valuearea = value.actions[0].area
      // console.log(valuearea.height == 1, valuearea.width == 1)
      if (valuearea.height == 1 && valuearea.width == 1) {
        this.hasLinkUrl = false
      } else {
        this.hasLinkUrl = true
        this.linkurl = value.actions[0].linkUri
      }
      this.image_url = img.replace('?_ignored=', '')
    },
    onCancel() {
      this.$emit('oncancel')
    },
    switchView() {
      this.type = this.type == 'ui' ? 'code' : 'ui'
      if (this.type == 'code') {
        if (this.$refs.cmCode) this.$refs.cmCode.codemirror.refresh()
      }
    },
    onCmCodeChange: function(newCode) {
      let c = ''
      try {
        if (!newCode.includes('?_ignored=')) {
          let a = newCode.split('"baseUrl": "')
          let b = a[1].split('",')
          c = a[0]
          for (let index = 0; index < b.length; index++) {
            if (index == 0) {
              c += '"baseUrl": "' + b[index] + '?_ignored=",'
            } else {
              if (index === b.length - 1) {
                c += b[index]
              } else {
                c += b[index] + '",'
              }
            }
          }
          this.code = c
          this.$emit('input', this.code)
        } else {
          this.code = newCode
          this.$emit('input', this.code)
        }
      } catch (error) {
        this.code = newCode
        this.$emit('input', this.code)
      }
    },
    async onSave() {
      var vm = this
      var result = await vm.$validator.validateAll()
      let code = null
      if (result) {
        if (this.type !== 'code') {
          try {
            code = JSON.parse(this.code)
          } catch (error) {}
          if (code && code.actions && code.actions.length > 0) {
            this.$set(code.actions[0].area, 'width', this.hasLinkUrl ? code.baseSize.width : 1)
            this.$set(code.actions[0].area, 'height', this.hasLinkUrl ? code.baseSize.height : 1)
            this.$set(code.actions[0], 'linkUri', this.hasLinkUrl ? this.linkurl : code.baseUrl)
          }
        }
        this.onCmCodeChange(code ? JSON.stringify(code) : this.code)
        await this.$nextTick()
        // var code = JSON.parse(this.value)

        // var newCode = JSON.stringify({
        //   type: 'imagemap',
        //   ...code
        // })

        // this.onCmCodeChange(newCode)

        this.$emit('onsave')
      }
    },
    onUploaded(url, size) {
      var newCode = JSON.stringify({
        type: 'imagemap',
        baseUrl: url + '?_ignored=',
        altText: this.dataAltText,
        baseSize: {
          width: size.width,
          height: size.height
        },
        actions: [
          {
            type: 'uri',
            linkUri: this.hasLinkUrl ? this.linkurl : url,
            area: {
              x: 0,
              y: 0,
              width: this.hasLinkUrl ? size.width : 1,
              height: this.hasLinkUrl ? size.height : 1
            }
          }
        ]
      })

      this.onCmCodeChange(newCode)
    }
  },
  watch: {
    value: function(newVal) {
      this.code = newVal
    },
    image_url_edit(newVal) {
      if (newVal) this.updateImage(newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.CodeMirror pre {
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}

.CodeMirror pre {
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentLineImageMapMessage.vue